import React from 'react';
import { storage, auth } from '../firebase';
import { SharedFileAttachmentUploader } from 'shared-lib';
import { Attachment } from 'shared-lib';
import { ref } from 'firebase/storage';

interface FileAttachmentUploaderProps {
  clientId: string;
  requestId: string;
  onUploadComplete: (attachments: Attachment[]) => void;
  onError: (error: Error) => void;
  onUploadStatusChange?: (isUploading: boolean) => void;
  maxFiles?: number;
  autoUpdate?: boolean;
  acceptedFileTypes?: string;
}

const FileAttachmentUploader: React.FC<FileAttachmentUploaderProps> = ({
  clientId,
  requestId,
  onUploadComplete,
  onError,
  onUploadStatusChange,
  maxFiles = 10,
  autoUpdate = true,
  acceptedFileTypes = "image/*,video/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv"
}) => {

  const getref = (path: string) => {
    return ref(storage, path);
  }

  const getStoragePath = (requestId: string, fileName: string) => {
    return `service_requests/${clientId}/${requestId}/attachments/${fileName}`;
  }

  return (  
    <SharedFileAttachmentUploader
      requestId={requestId}
      onUploadComplete={onUploadComplete}
      onUploadStatusChange={onUploadStatusChange}
      onError={onError}
      maxFiles={maxFiles}
      autoUpdate={autoUpdate}
        acceptedFileTypes={acceptedFileTypes}
        currentAuthUser={auth.currentUser}
        getref={getref}
        getStoragePath={getStoragePath}
      />
  );
};
export default FileAttachmentUploader; 